import * as React from "react";
const SvgIndex = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#14181F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.084 11.25 5 8.333.917 11.25V1.917A1.167 1.167 0 0 1 2.084.75h5.833a1.167 1.167 0 0 1 1.167 1.167v9.333Z"
    />
  </svg>
);
export default SvgIndex;